module.exports = __webpack_public_path__ + "img/lead-gen.c4404497.svg";